import { cloneDeep } from 'lodash';
const SET_FEEDBACK = 'SET_FEEDBACK';

const initialState = '';

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_FEEDBACK:
			return action.payload;
		default:
			return state;
	}
}

export function setFeedback(feedback){
	return{
		type: SET_FEEDBACK,
		payload: feedback
	};
}


export function delayedClearFeedback(){
	return dispatch => {
		setTimeout( () => {
			dispatch( clearFeedback() )
		}, 2000);
	};
}

export function clearFeedback(){
	return {
		type: SET_FEEDBACK,
		payload: ''
	}
}


// WEBPACK FOOTER //
// ./src/modules/feedback.js